import { render, staticRenderFns } from "./FoodCategories.vue?vue&type=template&id=33a1438b&"
import script from "./FoodCategories.vue?vue&type=script&lang=js&"
export * from "./FoodCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports